import React from 'react';
import ModalBox from 'react-responsive-modal';
import PropTypes from 'prop-types';

const LoginModal = (props) => {
    const { openModal = false, onCloseModal } = props;
    return (
        <ModalBox open={openModal}
            onClose={onCloseModal}
            classNames={{ modal: 'b2c__loginwrap', overlay: 'b2c__loginoverlay' }}>
            {props.children}
        </ModalBox>
    )
}

LoginModal.propTypes = {
    onCloseModal: PropTypes.func.isRequired
};

export default LoginModal;